import { render, staticRenderFns } from "./EMTagSelect.vue?vue&type=template&id=55125b2d&"
import script from "./EMTagSelect.vue?vue&type=script&lang=js&"
export * from "./EMTagSelect.vue?vue&type=script&lang=js&"
import style0 from "./EMTagSelect.vue?vue&type=style&index=0&id=55125b2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
